import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { absencesDelete } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useDeleteAbsence = (
  publisherId: number,
  options: UseMutationOptions<void, unknown, number, unknown>
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (absenceId) =>
      extractData(absencesDelete({ path: { publisherId, absenceId } })),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({ queryKey: ['absences', publisherId] });
      options.onSuccess?.(...args);
    },
  });
};
